'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LanguageKeys = {
  returnsCsrSignInError401: 'The current user is not authorized to access this order.',
  returnsCsrSignInError500: 'There was an error with sign in. Please try again.',
  returnsCsrSignInTitle: 'Customer Service Sign In',
  returnsCsrSignInDetails: 'Enter an Order Number and click Sign In to continue.',
  returnsCsrSignInOrderPlaceholder: 'Order Number',
  returnsCsrSignInPrimaryButton: 'Sign in with Narvar',
  returnsPudoListTitle: 'How would you like to return it?',
  returnsPudoListItemhomepickupTitle: 'Home Pickup',
  returnsPudoListItemhomepickupSubtitle: 'Home Pickup',
  returnsPudoListItemstoreTitle: 'Visit a store',
  returnsPudoListItemstoreSubtitle: 'No box or label needed',
  returnsPudoListItemstoreLinktext: 'Find a nearby store',
  returnsPudoListItemconciergepartnershipTitle: 'Dropoff Partner',
  returnsPudoListItemconciergepartnershipSubtitle: '',
  returnsPudoListItemprinterlessmailTitle: 'Printerless Drop-Off',
  returnsPudoListItemprinterlessmailSubtitle: 'Box your return. No label needed.',
  returnsPudoListItemmailTitle: 'Ship It Back',
  returnsPudoListItemmailSubtitle: 'Send your package back to us.',
  returnsPudoListItemmailLinktext: 'Find a nearby location',
  returnsPudoListShowall: '< Back to All Methods',
  returnsPudoListFeeLabellabelfee: 'Label Fee',
  returnsPudoListFeeLabelshippingfee: 'Shipping Fee',
  returnsPudoListFeeLabelpickupfee: 'Pickup Fee',
  returnsPudoListFeeLabelFree: 'FREE',
  returnsPudoListSwitchCategory: 'Select different return method',
  returnsPudoLocationsPostalcodeTitle: 'Choose your location near: ',
  returnsPudoLocationsPostalcodeSearch: 'Search',
  returnsPudoLocationsPostalcodeCancel: 'Cancel',
  returnsPudoLocationsDistanceUnitmiles: 'mi',
  returnsPudoLocationsDistanceUnitkilometers: 'km',
  returnsPudoLocationsDistanceNounit: 'Directions',
  returnsPudoPickupTimeslotTitle: 'We can pick up your return',
  returnsPudoPickupTimeslotDescription: 'The pickup window will be from {{earliestHour}} to {{latestHour}}.  <br/> Hand your package directly to courier or leave your package in a safe place for pickup.',
  returnsPudoPickupLocationTitle: 'Pickup Location',
  returnsPudoPickupLocationDescription: 'Returns can only be picked up from the original delivery address.',
  returnsPudoPickupInstructionsToggle: 'Add Pickup Instructions',
  returnsPudoPickupFeeTitle: '{{pickupFee}} Pickup Convenience Fee',
  returnsPudoPickupFeeDescription: 'This is a non-refundable fee in addition to any return shipping fees deducted from your return. <br/> Once the pickup is scheduled, it cannot be canceled.',
  returnsPudoPickupInstructionsPlaceholder: 'Take the lobby elevator up to the 3rd floor.',
  returnsPudoPickupInstructionsHandoffTitle: 'How will the courier pick up your package?',
  returnsPudoSubmit: 'Submit',
  returnsPudoLocationsSortedbyOptionrecommended: 'Recommended',
  returnsPudoLocationsSortedbyOptiondistance: 'Distance',
  returnsPudoLocationsSortedbyTitle: 'Sort By',
  returnsPudoLocationsSkipLink: 'or proceed without selecting a drop-off location',
  returnsPudoMultiLabelsTitle: 'How many shipping labels do you need?',
  returnsPudoMultiLabelsDescription: 'You’ll need one label per box',
  returnsPudoMultiLabelsInputPlaceholder: 'Number of labels',
  returnsPudoMultiLabelsRemarks: 'Putting your return items in correctly labeled boxes will help you get your refund faster.',
  returnsPudoErrorNopudooptions: 'No available return methods. Please try again later.',
  returnsPudoErrorNotimeslots: 'No available pickup timeslots. Please go back and choose a different return method.',
  returnsOrderLoginAbove: '',
  returnsOrderLoginBelow: '',
  returnsOrderLoginFormAbove: '',
  returnsOrderLoginFormBelow: '',
  returnsOrderLoginSubmitAbove: '',
  returnsOrderLoginSubmitBelow: '',
  returnsOrderLoginTitleBelow: '',
  returnsOrderLoginFieldsAbove: '',
  returnsOrderLoginTitle: 'Returns',
  returnsOrderLoginDescription: 'Enter your order information to get started.',
  returnsOrderLoginFormSubmit: 'Next',
  returnsOrderLoginFormLabelEmail: 'Email',
  returnsOrderLoginFormLabelOrder: 'Order Number',
  returnsOrderLoginFormLabelGiftCode: 'Gift Code',
  returnsOrderLoginFormCaptionEmail: "We'll use this to send you your return label and refund.",
  returnsOrderLoginFormCaptionOrder: '',
  returnsOrderLoginFormCaptionGiftCode: "Can't find this? Try looking on your gift receipt, or email customer service and we'll help you out.",
  returnsOrderLoginReturnPolicy: 'Read our Return Policy',
  returnsOrderLoginError: 'We could not find the order. Please confirm information is correct and try again.',
  returnsOrderLoginFormValidationErrorEmail: 'Please enter a valid email address.',
  returnsOrderLoginToggleGiftReturnTitle: 'Returning a gift?',
  returnsOrderLoginToggleGiftReturnLinkText: 'Start a gift return',
  returnsOrderLoginToggleGiftReturnTitle_giftReturn: 'Not returning a gift?',
  returnsOrderLoginToggleGiftReturnLinkText_giftReturn: 'Start a return',
  returnsReasonsItemInfoTitle: '{{name}}',
  returnsReasonsItemInfoColor: 'Color: {{color}}',
  returnsReasonsItemInfoColorLabel: 'Color:',
  returnsReasonsItemInfoSize: 'Size: {{size}}',
  returnsReasonsItemInfoSizeLabel: 'Size:',
  returnsReasonsItemInfoQuantity: 'Quantity: {{quantity}}',
  returnsReasonsItemInfoQuantityLabel: 'Quantity:',
  returnsReasonsItemInfoQuantitySelectPlaceholder: 'Number of Items',
  returnsReasonsTypeTitle: `What would you like to do?`,
  returnsReasonsTypeReturn: `Return`,
  returnsReasonsTypeExchange: `Exchange`,
  returnsReasonsTypeClaim: `Report shipping issue`,
  returnsReasonsListTitle: `What didn't go as planned?`,
  returnsReasonsListTitleSecondary: 'Specify more detail',
  returnsReasonsQuantityTitle: 'How many would you like to return?',
  returnsReasonsQuantityAllTitle: 'Is the item unopened and the full quantity being returned?',
  returnsReasonsQuantityAllTitleHipaa: 'Is the item unopened and the full prescription quantity being returned?',
  returnsReasonsQuantityAllYesLabel: 'Yes',
  returnsReasonsQuantityAllNoLabel: 'No',
  returnsReasonsQuantityAllError: 'Only unopened items that include their full quantity can be returned.',
  returnsReasonsPicturesTitle: 'Please upload a photo',
  returnsReasonsPicturesUploadButton: 'Choose Photo',
  returnsReasonsPicturesUploadDescription: 'Please upload a PNG or JPG up to 10MB',
  returnsReasonsPicturesUploadErrorMaxSize: 'Images must be smaller than 10MB.',
  returnsReasonsPicturesUploadErrorMaxCount: 'Please upload 1 or 2 photos.',
  returnsReasonsCommentsTitle: 'Anything else to share?',
  returnsReasonsCommentsPlaceholder: 'Leave a comment (optional)',
  returnsReasonsCommentsPlaceholderRequired: 'Leave a comment (required)',
  returnsReasonsEditTitle: 'Remove item?',
  returnsReasonsEditRemoveLabel: 'Yes, remove item',
  returnsReasonsEditContinueLabel: 'No, continue with return',
  returnsReasonsNoReasonsError: 'No return reasons available.',
  returnsReasonsExchangeTitle: 'Would you like to exchange for another size or color?',
  returnsReasonsExchangeUnavailable: 'This product is unavailable for exchange.',
  returnsReasonsExchangeUpsellTitle: 'Would you like to exchange for something else?',
  returnsReasonsExchangeUpsellNoThanks: 'No thanks',
  returnsReasonsShopNowDescription: 'Not seeing what you want?',
  returnsReasonsShopNowLink: 'Shop now with credit instead',
  returnsConfirmationstoreActionsPanelHeader: 'RETURN SHIPPING LABEL',
  returnsConfirmationstoreActionsPanelTitle: `Here's your store return slip`,
  returnsConfirmationstoreActionsPanelTitleHipaa: 'Check your email for your return slip',
  returnsConfirmationstoreActionsPanelMainButton: 'Print Store Return Slip',
  returnsConfirmationstoreActionsPanelDescription: 'A confirmation email has been sent to {{email}}',
  returnsConfirmationstoreActionsPanelDescriptionHipaa: 'A confirmation email has been sent to your email address.',
  returnsConfirmationstoreActionsPanelEmailButton: 'Send to another email address',
  returnsConfirmationActionsPanelEmailStatusidle: '',
  returnsConfirmationActionsPanelEmailStatuserror: 'There appears to be an issue sending to the new email address. Please try again later.',
  returnsConfirmationActionsPanelEmailStatusloading: '',
  returnsConfirmationActionsPanelEmailStatussuccess: '',
  returnsConfirmationActionsPanelEmailStatusvalidationerror: `There appears to be a problem with this email address. Please check and try again.`,
  returnsConfirmationActionsPanelEmailInputPlaceholder: 'Email',
  returnsConfirmationstoreInstructionsPanelHeader: 'INSTRUCTIONS',
  returnsConfirmationstoreStep1Title: `Print your return slip`,
  returnsConfirmationstoreStep1Details: `If you're unable to print, you can show an associate your confirmation email.`,
  returnsConfirmationstoreStep2Title: `Visit our store`,
  returnsConfirmationstoreStep2Details: `Bring along your return items and the return slip. Our sales associate will be happy to help complete your return or exchange.`,
  returnsConfirmationstoreItemsPanelHeader: 'ITEMS TO RETURN',
  returnsConfirmationmailActionsPanelHeader: 'RETURN SHIPPING LABEL',
  returnsConfirmationmailActionsPanelTitle: `Here's your {{provider}} return shipping label`,
  returnsConfirmationmailActionsPanelTitleHipaa: 'Check your email for your return shipping label',
  returnsConfirmationmailActionsPanelMainButton: 'Print Return Shipping Label',
  returnsConfirmationmailActionsPanelDescription: 'A confirmation email has been sent to {{email}}',
  returnsConfirmationmailActionsPanelDescriptionHipaa: 'A confirmation email has been sent to your email address.',
  returnsConfirmationmailActionsPanelEmailButton: 'Send to another email address',
  returnsConfirmationmailInstructionsPanelHeader: 'INSTRUCTIONS',
  returnsConfirmationmailStep1Title: `Print your return shipping label`,
  returnsConfirmationmailStep2Title: `Pack up your items`,
  returnsConfirmationmailStep2Details: `Place your packing slip and items in the original or new package, and seal it. Mark out any old addresses and barcodes, then attach your return shipping label.`,
  returnsConfirmationmailStep3Title: `Ship your package with {{provider}}`,
  returnsConfirmationmailStep3Details: `You can ship for package to us any way you like, either using a drop box or bringing it to a drop-off location.`,
  returnsConfirmationmailItemsPanelHeader: 'ITEMS TO RETURN',
  returnsConfirmationprinterless_mailActionsPanelHeader: `MOBILE RETURN CODE`,
  returnsConfirmationprinterless_mailActionsPanelTitle: `Here's your {{provider}} mobile return code`,
  returnsConfirmationprinterless_mailActionsPanelTitleHipaa: `Check your email for your mobile return code`,
  returnsConfirmationprinterless_mailActionsPanelDescription: `This {{provider}} mobile return code was also sent via email to {{email}}`,
  returnsConfirmationprinterless_mailActionsPanelDescriptionHipaa: 'Your mobile return code was also sent to your email address.',
  returnsConfirmationprinterless_mailActionsPanelEmailButton: `Send to another email address`,
  returnsConfirmationprinterless_mailLocationPanelHeader: `DROP-OFF LOCATION`,
  returnsConfirmationprinterless_mailInstructionsPanelHeader: `INSTRUCTIONS`,
  returnsConfirmationprinterless_mailStep1Title: `Pack up your items`,
  returnsConfirmationprinterless_mailStep1Details: `Place your items in the original or new packaging, and seal it. Mark out any old addresses and barcodes.`,
  returnsConfirmationprinterless_mailStep2Title: `Bring your return to {{location}}`,
  returnsConfirmationprinterless_mailStep2TitleHipaa: 'Bring your return to your preferred location',
  returnsConfirmationprinterless_mailStep3Title: `Ship your package with {{provider}}`,
  returnsConfirmationprinterless_mailStep3Details: `You can ship for package to us any way you like, either using a drop box or bringing it to a drop-off location.`,
  returnsConfirmationprinterless_mailItemsPanelHeader: `ITEMS TO RETURN`,
  returnsConfirmationprinterless_mailSecondaryActionsPanelTitle: `Need to print a return label?`,
  returnsConfirmationprinterless_mailSecondaryActionsPanelDescription: `If you change your mind or your mobile return code isn't working, you can always print your label instead.`,
  returnsConfirmationprinterless_mailSecondaryActionsPanelMainButton: `Get label`,
  returnsConfirmationconciergeActionsPanelHeader: 'RETURN SHIPPING LABEL',
  returnsConfirmationconciergeActionsPanelTitle: `Here's your {{provider}} return shipping label`,
  returnsConfirmationconciergeActionsPanelTitleHipaa: 'Check your email for your return shipping label',
  returnsConfirmationconciergeActionsPanelMainButton: 'Print Return Shipping Label',
  returnsConfirmationconciergeActionsPanelDescription: 'A confirmation email has been sent to {{email}}',
  returnsConfirmationconciergeActionsPanelEmailButton: 'Send to another email address',
  returnsConfirmationconciergeLocationPanelHeader: `DROP-OFF LOCATION`,
  returnsConfirmationconciergeInstructionsPanelHeader: 'INSTRUCTIONS',
  returnsConfirmationconciergeStep1Title: `Print your return shipping label`,
  returnsConfirmationconciergeStep2Title: `Pack up your items`,
  returnsConfirmationconciergeStep2Details: `Place your packing slip and items in the original or new package, and seal it. Mark out any old addresses and barcodes, then attach your return shipping label.`,
  returnsConfirmationconciergeStep3Title: `Ship your package with {{provider}}`,
  returnsConfirmationconciergeStep3Details: `You can ship for package to us any way you like, either using a drop box or bringing it to a drop-off location.`,
  returnsConfirmationreshopStepTitle: 'Download the <span style="color: #ff5734">Reshop</span> app to finish getting your refund.',
  returnsConfirmationreshopStepDetails: 'Once you’re set up, we’ll send your money to your bank account',
  returnsConfirmationreshopStepAppStoreLink: 'https://apps.apple.com/us/app/reshop-app/id6457265704',
  returnsConfirmationreshopStepAppStoreLinkText: 'Download on the App Store',
  returnsConfirmationreshopStepGooglePlayLink: 'https://play.google.com/store/apps/details?id=com.reshopmobile',
  returnsConfirmationreshopStepGooglePlayLinkText: 'Get it on Google Play',
  returnsConfirmationconciergeItemsPanelHeader: 'ITEMS TO RETURN',
  returnsConfirmationError: 'We could not find the return. Try again later.',
  returnsMonikerfedexDisplayName: `FedEx`,
  returnsMonikerfedexLinkText: 'Find a drop-off location',
  returnsMonikerfedexLinkUrl: 'https://local.fedex.com/',
  returnsMonikerupsDisplayName: `UPS`,
  returnsMonikerupsLinkText: 'Find a drop-off location',
  returnsMonikerupsLinkUrl: 'https://www.ups.com/dropoff',
  returnsMonikeruspsDisplayName: `USPS`,
  returnsItemListTitle: 'Hi {{customer}}, what item can we help you with?',
  returnsItemListTitleHipaa: 'Hello. What would you like to return?',
  returnsItemListTitleDirty: 'Can we help you with anything else, {{customer}}?',
  returnsItemListTitleDirtyHipaa: 'Please review the item to be returned and click Next to proceed. Click the item if you want to make changes.',
  returnsItemListIneligibleTitle: 'You have no eligible items for return.',
  returnsItemListEligibleDescription: 'These items can be returned until {{returnDate}}',
  returnsItemListReturnInitiatedTitle: 'Return Initiated',
  returnsItemListPendingpacking_slip_and_shipping_labelLink: 'Reprint Shipping Label',
  returnsItemListPendingqr_codeLink: 'Get Mobile Return Code',
  returnsItemListPendingpacking_slipLink: 'Reprint Packing Slip',
  returnsItemListPendingshipping_labelLink: 'Reprint Shipping Label',
  returnsItemListPendingCancelReturnLink: 'Cancel Return',
  returnsItemListIneligibleDescription: 'Not Eligible for Return',
  returnsItemListSubmit: 'Next',
  returnsItemListItemInfoTitle: '{{name}}',
  returnsItemListItemInfocolorLabel: 'Color: ',
  returnsItemListItemInfoskuLabel: 'SKU: ',
  returnsItemListItemInfoqtyLabel: 'Quantity: ',
  returnsItemListItemInfosizeLabel: 'Size: ',
  returnsItemListItemInfoqtyTransactionSeparator: ' -> ',
  returnsItemListItemInfopriceLabel: 'Price: ',
  returnsItemListItemInforeasonLabel: 'Reason: ',
  returnsItemListItemTagReturning: 'Returning',
  returnsItemListItemTagExchanging: 'Exchanging',
  returnsItemListItemTagClaiming: 'Returning',
  returnsItemListItemTagHasShippingProtection: 'Shipping Protection',
  returnsItemListItemTagHasShippingProtectionTooltip: 'Item is protected if it is delivered damaged, lost during delivery, or stolen. <a href="#">Learn more</a>',
  returnsItemListItemTagExchangingForCredit: 'Exchanging for Credit',
  returnsItemListNoItemError: 'No valid items in this order to be returned.',
  returnsItemListBannererror: 'Sorry, we are unable to cancel your return at this time. Please try again later. ',
  returnsItemListBannersuccess: 'Your return was successfully cancelled. ',
  returnsLineItemGroupIneligibleDescription: 'These items need to be returned to a different location. You can return these items after completing the return for your selected item(s).',
  returnsLineItemGroupTitle: 'Sold by {{group}}',
  returnsReviewError: 'Unfortunately, we are unable to complete your return at this time. Please try again later.',
  returnsReviewHeader: 'Does everything look right?',
  returnsReviewDescriptionmail: `You'll be able to download your prepaid shipping label once your return is submitted.`,
  returnsReviewDescriptionconcierge: `You'll be able to download your prepaid shipping label once your return is submitted.`,
  returnsReviewDescriptionprinterless_mail: `You'll receive a Mobile Return Code once your return is submitted.`,
  returnsReviewDescriptionstore: `You will be able to download a return slip to take to our store once you submit your return.`,
  returnsReviewDescriptionself: `You'll be able to download your packing slip once your return is submitted.`,
  returnsReviewSubHeader: 'Return Summary',
  returnsReviewSubHeaderExchange: 'Exchange Summary',
  returnsReviewSubHeaderReturnAndExchange: 'Return and Exchange Summary',
  returnReviewTitleShopNow: 'Shopping Cart',
  returnsReviewItemCardSize: 'Size',
  returnsReviewItemCardQuantity: 'Quantity',
  returnsReviewTotalsSubtotal: 'Subtotal',
  returnsReviewTotalsShippingFee: 'Return Shipping Fee',
  returnsReviewTotalsEstimatedRefund: 'Estimated Refund',
  returnsReviewTotalsEstimatedCharge: 'Total',
  returnsReviewTotalsHelpText: '* This is an estimate. Actual refund amount is subject to applied discounts, tax, shipping costs, and item condition.',
  returnsReviewDropOffLocationHeader: 'Drop-Off Location Details',
  returnsReviewAddEmailHeader: 'Customer Email Address',
  returnsReviewAddEmailDescription: `Before submitting this return, please include the customer's email address. Return instructions and the shipping label will be sent to this address.`,
  returnsReviewUpdateEmailDescription: `If you need to update the customer's email address, enter it below. Return instructions and the shipping label will be sent to to this new address along with any future notifications on this return.`,
  returnsReviewAddEmailInputLabel: 'Email Address',
  returnsReviewSubmittingReturn: 'Submitting Return',
  returnsReviewSubmittingError: 'There was a problem processing this return. Try again later.',
  returnsReviewPolicyCheckbox: '',
  returnsReviewRefundTo_originalPayment: 'to {{name}}',
  returnsReviewRefundTo_giftCard: 'to {{name}}',
  returnsReviewPreferencesCheckboxLabel: 'Save your returns methods & preferences to use for future returns with retailers who use Narvar. You can add, update or delete your preferences at any time. <a href="#/">Learn more</a>',
  returnsReviewPreferencesInputLabel: 'Confirm your email associated with this order',
  returnsReviewReshopTitle: 'Get Text Updates About Your Refund with <span style="color:#FF5734;font-weight:700;">Reshop</span>',
  returnsReviewReshopCheckboxLabel: 'I want to receive texts from Reshop about my refund',
  returnsReviewReshopPhoneInputLabel: 'Mobile Number',
  returnsReviewReshopDisclaimer: '*Assuming we need some sort of disclaimer text here',
  returnsRefundMethodsTitle: 'How would you like to receive your refund?',
  returnsRefundMethodsDisclaimer: '',
  returnsRefundMethodsOptionOriginalPaymentTitle: 'Original Form of Payment',
  returnsRefundMethodsOptionOriginalPaymentDescription: 'Receive a refund to your original form of payment 5-7 days after your return is processed.',
  returnsRefundMethodsOptionGiftCardTitle: 'Gift Card',
  returnsRefundMethodsOptionGiftCardDescription: 'Receive a gift card to your email after your return is processed.',
  returnsRefundMethodsOptionReshopTitle: 'Instant Refund with <span style="color: #FF5734">Reshop</span>',
  returnsRefundMethodsOptionReshopDescription: 'Get your refund in the Reshop app right after submitting your return. <a target="_blank" href="https://www.reshop.com/">Learn more about Reshop</a>',
  returnsRefundMethodsOptionIncentiveChip: 'GET {{amount}}',
  returnsSwatchesListSeeMore: 'See More',
  returnsSwatchesListSeeLess: 'See Less',
  returnsPreferencesStatusDesc: 'Your return preferences have been applied.',
  returnsPreferencesStatusDesc_error: "We were unable to save your return preferences since your email address couldn't be verified.",
  returnsPreferencesStatusDesc_pending: 'Your return preferences have been saved. Complete your profile to apply them to future returns.',
  returnsPreferencesStatusLinkText: 'Manage your preferences',
  returnsPreferencesStatusLinkText_error: 'Create your profile',
  returnsPreferencesStatusLinkText_pending: 'Complete profile',
  returnsStepsGeneralError: 'There was an error loading the next step. Please try again later.',
  returnsActionsNext: 'Next',
  returnsActionsBack: 'Back',
  returnsActionsCancel: 'Cancel',
  returnsActionsSubmit: 'Submit',
  returnsActionsBackToLogin: 'Return to Order Login'
};

exports["default"] = LanguageKeys;
